import React from "react";

export default function SettlementPdfSummaryGrid({ cards, columns = 4 }) {
  return (
    <div className={`settlement-pdf-summary-grid settlement-pdf-summary-grid--${columns}`}>
      {cards.map((card) => (
        <div className={`settlement-pdf-summary-card ${card.modifier || ""}`} key={card.title}>
          <div className="settlement-pdf-summary-title">{card.title}</div>
          <div className="settlement-pdf-summary-value">{card.value}</div>
        </div>
      ))}
    </div>
  );
}
